module.exports = __webpack_public_path__ + "img/tr.56a910da.svg";